import React from 'react';
import TagsUrlInputWrapper from './TagsUrlInputWrapper';

class ExternalDocumentTagsUrlInputWrapper extends React.Component {
  getTagLink = tagValue => {
    return window.REACT_APP_EXTERNAL_DOCUMENT_REPO_URL_PATH + tagValue;
  };

  render() {
    return <TagsUrlInputWrapper {...this.props} urlTagLink={this.getTagLink} />;
  }
}

ExternalDocumentTagsUrlInputWrapper.defaultProps = {
  onlyAutocomplete: false
};

export default ExternalDocumentTagsUrlInputWrapper;
